// Which toy each place becomes in the Crate (docs/REMEDIATION_3D_LOOK.md). Pure and three-free,
// so screens can use it; the 3D models live in src/stage/crate/toys.ts.
import type { Pack, Place } from '../../shared/pack/schema'

export type CrateToy = 'ramen' | 'bucket' | 'chair' | 'float' | 'can' | 'snowman' | 'train' | 'tower'

const TOY_FOR_KIND: Record<string, CrateToy> = {
  food: 'ramen',
  onsen: 'bucket',
  snow: 'chair',
  poi: 'tower',
  shop: 'can',
  activity: 'snowman',
  transit: 'train',
}
/** Canal and glassworks places get the Otaru glass float instead of the generic sight. */
const FLOAT_TAGS = ['canal', 'glass', 'glassworks']
const ORDER: CrateToy[] = ['ramen', 'bucket', 'chair', 'float', 'tower', 'can', 'snowman', 'train']

export function toyFor(place: Place): CrateToy {
  if (place.tags.some((t) => FLOAT_TAGS.includes(t))) return 'float'
  return TOY_FOR_KIND[place.kind] ?? 'tower'
}

/** One toy per kind of place the pack has, in a fixed order, with the places behind each. */
export function crateToys(pack: Pack): { toy: CrateToy; places: Place[] }[] {
  const by = new Map<CrateToy, Place[]>()
  for (const p of pack.places) by.set(toyFor(p), [...(by.get(toyFor(p)) ?? []), p])
  return ORDER.filter((t) => by.has(t)).map((toy) => ({ toy, places: by.get(toy)! }))
}

/** The toys each Crate filter chip picks out (by chip index; matches t.crate.filters). */
export const FILTER_TOYS: (CrateToy[] | null)[] = [null, ['ramen'], ['bucket'], ['chair', 'snowman'], []]
